
import React from "react";

interface InBoxIconProps {
  className?: string;
  size?: number;
}

const InBoxIcon: React.FC<InBoxIconProps> = ({ 
  className = "", 
  size = 18
}) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 18 18" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect 
        x="1" 
        y="1" 
        width="16" 
        height="16" 
        rx="6" 
        stroke="#6B7789" 
        strokeWidth="2" 
        fill="none"
      />
    </svg>
  );
};

export default InBoxIcon;
